import axios from 'axios';

export const listSections = async ({ eventId }) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_EVENT_BASE_URL}/${eventId}/section`
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const createSection = async ({ headers, payload, eventId }) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_EVENT_BASE_URL}/${eventId}/section`,
      payload,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const updateSection = async ({ headers, payload, eventId, sectionId }) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_EVENT_BASE_URL}/${eventId}/section/${sectionId}`,
      payload,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const updateSectionMany = async ({ headers, payload }) => {
  const eventId = payload.event._id;

  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_EVENT_BASE_URL}/${eventId}/section/update/many`,
      payload,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const deleteSection = async ({ headers, eventId, sectionId }) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_EVENT_BASE_URL}/${eventId}/section/${sectionId}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};
